import React, { FC } from 'react';
import { Box, Stack } from '@mui/material';
import { Icon } from '@iconify/react';
import Button from '../../components/Button/Button';
import { Typography } from '../../components';

type Props = {
  transactionErrors: any;
  retryCall: any;
};

const errorBox = (errorType: string, errorMsg: string) => {
  return (
    <Box sx={{ display: 'flex' }}>
      <Box>
        <Icon icon="ri:information-line" color="#E04732" width="16px" height="16px" style={{ paddingTop: '2px' }} />
      </Box>
      <Typography weight={400} size={12} color="#E04732" marginLeft={1} lineHeight={1.7}>
        {errorType}: {errorMsg}
      </Typography>
    </Box>
  );
};

const successBox = (successType: string, successMsg: string) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Icon icon="mdi:check-circle-outline" width="16px" height="16px" color="#1B1B1B" />
      <Typography weight={400} size={12} color="#1B1B1B" marginLeft={1} lineHeight={1.7}>
        {successType}: {successMsg}
      </Typography>
    </Box>
  );
};

const AssignmentAlert: FC<Props> = ({ transactionErrors, retryCall }) => {
  const { sfdcResponse, vmsResponse } = transactionErrors;

  return (
    <Stack direction="row" alignItems="center" justifyContent="flex-end" gap={1}>
      <Box
        width="100%"
        sx={{
          border: 1,
          borderRadius: '4px',
          borderColor: '#E04732',
          padding: '7px 10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box>
          {sfdcResponse?.statusCode !== 200
            ? errorBox('Salesforce', sfdcResponse?.data)
            : successBox('Salesforce', sfdcResponse?.data)}
          {vmsResponse?.statusCode !== 200 ? errorBox('SAP', vmsResponse?.data) : successBox('SAP', vmsResponse?.data)}
        </Box>
        <Box>
          <Button
            size="small"
            onClick={() => retryCall()}
            color="error"
            sx={{
              border: 1,
              borderRadius: '4px',
              borderColor: '#E04732',
              fontSize: '12px',
              fontWeight: '400px',
              textTransform: 'capitalize',
              lineHeight: '15.6px',
              padding: '7px 10px',
            }}
          >
            Retry
          </Button>
        </Box>
      </Box>
    </Stack>
  );
};

export default AssignmentAlert;
